import React from "react";

const Services = () => {
  return <div>Services page is under construction</div>;
};

export default Services;
